<template>
    <div>
        <div v-if="!searching">
            <h1>
                <b-link
                    title="Client précédent"
                    :disabled="!hasPrevious"
                    variant="outline-primary"
                    @click="goToPrevious"
                >
                    <i class="fa-fw fal fa-caret-left menu-icon"></i>
                </b-link>
                <b-link title="Rechercher un client" @click="showSearch">
                    {{ clientData.name }}
                </b-link>
                <b-link
                    title="Client suivant"
                    :disabled="!hasNext"
                    variant="outline-primary"
                    @click="goToNext"
                >
                    <i class="fa-fw fal fa-caret-right menu-icon"></i>
                </b-link>
            </h1>
        </div>
        <div v-else class="mb-3">
            <search-client-big
                v-if="searching"
                @client-is-set="goToClient"
                @hide-me="hideSearch"
            />
        </div>
    </div>
</template>

<script>
import SearchClientBig from '../../activity_management/clients/components/SearchClientBig.vue'

export default {
    name: 'ClientNavigator',

    components: { SearchClientBig },

    props: {
        clientData: {
            type: Object,
            required: true,
        },
        routeData: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            searching: false,
        }
    },

    computed: {
        inputClass() {
            return this.searching ? 'search-class' : 'display-class'
        },

        hasPrevious() {
            return this.clientData.previous !== null
        },

        hasNext() {
            return this.clientData.next !== null
        },
    },

    methods: {
        showSearch() {
            if (this.routeData.suffix !== 'missions') {
                this.searching = true
            }
        },

        hideSearch() {
            this.searching = false
        },

        goToClient(client) {
            this.goTo(client.uuid)
        },

        goToPrevious() {
            this.goTo(this.clientData.previous.uuid)
        },

        goToNext() {
            this.goTo(this.clientData.next.uuid)
        },

        goTo(uuid) {
            window.location.href = `${this.routeData.prefix + uuid}/${
                this.routeData.suffix
            }`
        },
    },
}
</script>

<style scoped>
.client-title {
    font-size: 26px;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}

.search-class {
    background-color: white !important;
}

.display-class {
    border: none;
    background-color: #fafcff !important;
}
</style>
